/**
 * Parses search string, returns object with get-parameters
 * @param search - search string (window.location.search)
 */
export function getUrlParams(search: string): { [key: string]: string } {
  const hashes = search.slice(search.indexOf('?') + 1).split('&');
  const params = {};
  hashes.forEach(hash => {
    const [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
}